export const DE_MALE_NAMES = [
    // Most popular current German male names
    "Emil", "Noah", "Paul", "Elias", "Anton", "Levi", "Theo", "Moritz", "Ben", "Oskar",
    "Matteo", "Finn", "Liam", "Felix", "Leon", "Lino", "Lio", "Milo", "Jonas", "Henry",
    "Henri", "Luis", "Louis", "Mats", "Max", "Jakob", "Alexander", "Samuel", "Jonah", "David",
    
    // Traditional German names
    "Friedrich", "Wilhelm", "Heinrich", "Karl", "Franz", "Georg", "Johann", "Ludwig", "Otto", "Gustav",
    "Rudolf", "Adolf", "Ernst", "Walter", "Helmut", "Hans", "Werner", "Gerhard", "Klaus", "Manfred",
    "Günter", "Günther", "Wolfgang", "Bernd", "Jürgen", "Dieter", "Horst", "Peter", "Uwe", "Michael",
    "Andreas", "Thomas", "Stefan", "Christian", "Markus", "Matthias", "Jörg", "Rainer", "Frank", "Jochen",
    "Bernhard", "Reinhard", "Volker", "Rolf", "Hartmut", "Norbert", "Siegfried", "Lothar", "Rüdiger", "Detlef",
    
    // Regional variations and diminutives
    "Fritz", "Willi", "Willy", "Sepp", "Basti", "Hannes", "Klaas", "Lukas", "Lucas", "Niklas",
    "Niclas", "Tobias", "Sebastian", "Florian", "Fabian", "Adrian", "Bastian", "Constantin", "Konstantin", "Maximilian",
    "Benjamin", "Jonathan", "Dominik", "Dominic", "Philipp", "Philip", "Vincent", "Julian", "Daniel", "Gabriel",
    "Rafael", "Raphael", "Michael", "Christopher", "Christoph", "Oliver", "Simon", "Martin", "Robert", "Richard",
    
    // Modern German names
    "Luca", "Luka", "Milan", "Emilio", "Valentin", "Marlon", "Aaron", "Bruno", "Erik", "Eric",
    "Malik", "Kilian", "Kylian", "Nico", "Niko", "Gabriel", "Tim", "Leonard", "Malte", "Kian",
    "Kiyan", "Artur", "Arthur", "Miran", "Luke", "Luc", "Luan", "Levin", "Joshua", "Charlie",
    "Charly", "Amir", "Tiago", "Thiago", "Mattis", "Mathis", "Matthis", "Lion", "Benno", "Ali",
    "Noel", "Lorenz", "Willi", "Nils", "Niels", "Marlo", "Leopold", "Leonardo", "Jonte", "Elian",
    
    // Historical German names
    "Adalbert", "Albrecht", "Alois", "Alwin", "Ansgar", "Arnold", "Armin", "Arno", "Baldur", "Bodo",
    "Burghard", "Conrad", "Konrad", "Dietmar", "Eberhard", "Eckhard", "Egon", "Erich", "Erwin", "Eugen",
    "Ferdinand", "Fridolin", "Gottfried", "Gotthard", "Gregor", "Hagen", "Harald", "Hartwig", "Hasso", "Heiko",
    "Herbert", "Hermann", "Hubertus", "Hugo", "Ingo", "Joachim", "Josef", "Joseph", "Jürgen", "Justus",
    "Kaspar", "Kasimir", "Kurt", "Lambert", "Leonhard", "Linus", "Lorenz", "Ludger", "Magnus", "Manfred",
    
    // Bavarian and Austrian influenced names
    "Xaver", "Xavier", "Severin", "Benedikt", "Benedict", "Ignaz", "Ignatius", "Alban", "Blasius", "Clemens",
    "Cornelius", "Cyril", "Damian", "Erasmus", "Quirin", "Quirinus", "Laurenz", "Laurentius", "Vincenz", "Vinzenz",
    "Aegidius", "Agapitus", "Ambrosius", "Anastasius", "Antonius", "Apollinaris", "Aquilin", "Arsenius", "Athanasius", "Augustinus",
    "Aurelianus", "Bartholomäus", "Blasius", "Bonaventura", "Bonfatius", "Candidus", "Canisius", "Casimir", "Celestin", "Chrysostomus",
    
    // Northern German names
    "Sören", "Sven", "Lars", "Nils", "Ole", "Ove", "Peer", "Ragnar", "Rune", "Thorsten",
    "Torsten", "Ulf", "Viggo", "Björn", "Dag", "Einar", "Gunnar", "Haakon", "Ivar", "Jarle",
    "Kjell", "Knut", "Leif", "Magnus", "Morten", "Olaf", "Rolf", "Sigurd", "Sindre", "Stein",
    "Sverre", "Trygve", "Ulrich", "Yngve", "Åke", "Anders", "Axel", "Bo", "Carl", "Emil",
    
    // Shortened forms and nicknames
    "Alex", "Andy", "Andi", "Benny", "Bernie", "Christo", "Danny", "Eddie", "Freddy", "Gerry",
    "Harry", "Jacky", "Jimmy", "Johnny", "Kenny", "Larry", "Manny", "Marty", "Mickey", "Nicky",
    "Patty", "Randy", "Robby", "Rocky", "Ronny", "Sammy", "Teddy", "Terry", "Tommy", "Tony",
    "Willy", "Wolfy", "Adi", "Berti", "Didi", "Flo", "Gabi", "Hansi", "Heinz", "Helli",
    
    // International names popular in Germany
    "Antonio", "Carlo", "Francesco", "Giovanni", "Giuseppe", "Lorenzo", "Marco", "Mario", "Matteo", "Paolo",
    "Roberto", "Sergio", "Stefano", "Vincenzo", "André", "Antoine", "Henri", "Jean", "Louis", "Marcel",
    "Michel", "Nicolas", "Pascal", "Pierre", "René", "Thierry", "Yves", "Ahmed", "Hassan", "Ibrahim",
    "Mehmet", "Mohammed", "Mustafa", "Omar", "Osman", "Yusuf", "Ivan", "Nikola", "Stefan", "Vladimir",
    
    // Modern trendy names
    "Mika", "Lian", "Juna", "Kira", "Mira", "Nora", "Zara", "Aria", "Luna", "Maja",
    "Neo", "Rio", "Kenzo", "Milo", "Nico", "Diego", "Lino", "Nino", "Timo", "Vito",
    "Elia", "Eliah", "Kael", "Cael", "Zael", "Jael", "Nael", "Rael", "Gael", "Bael",
    "Dante", "Romeo", "Giulio", "Fabio", "Lucio", "Sergio", "Mattia", "Alessio", "Dario", "Flavio",
    
    // Compound German names
    "Karl-Heinz", "Hans-Peter", "Klaus-Dieter", "Hans-Jürgen", "Karl-Friedrich", "Johann-Wolfgang", "Ernst-August", "Friedrich-Wilhelm",
    "Georg-Friedrich", "Heinrich-Wilhelm", "Johann-Sebastian", "Karl-Ludwig", "Ludwig-Wilhelm", "Max-Emanuel", "Otto-Heinrich", "Wilhelm-Friedrich",
    
    // Germanic warrior names
    "Adalbert", "Adelbert", "Alberich", "Arnulf", "Berthold", "Bertram", "Bertrand", "Eberhart", "Engelbert",
    "Gebhard", "Gernot", "Gerwig", "Gotthard", "Gunther", "Haribert", "Hartmut", "Hartwig", "Heribert",
    "Hildebert", "Hildebrand", "Humbert", "Ingbert", "Lambert", "Luitpold", "Norbert", "Raimund", "Raymund",
    "Reinbert", "Reinhard", "Reinhold", "Ricbert", "Richbert", "Roderich", "Rupert", "Ruprecht", "Siegbert",
    "Siegfried", "Siegmund", "Theoderich", "Waldemar", "Waldram", "Wigbert", "Wilbert", "Wolfram", "Wulfram",
    
    // Saint names popular in Germany
    "Albertus", "Aloysius", "Amandus", "Ambrosius", "Andreas", "Ansgar", "Antonius", "Bernhard", "Blasius",
    "Bonaventura", "Bonifatius", "Chrysostomus", "Clemens", "Cornelius", "Cyriakus", "Damasus", "Dominikus",
    "Eligius", "Emmeram", "Erasmus", "Eusebius", "Expeditus", "Fidelis", "Franziskus", "Gallus", "Gordian",
    "Gregorius", "Hubertus", "Ignatius", "Innocentius", "Januarius", "Jeremias", "Joachim", "Johannes",
    "Judas", "Justinus", "Kilian", "Koloman", "Laurentius", "Leodegar", "Magnus", "Marcellus", "Martinus",
    "Mauritius", "Maximilianus", "Methodius", "Nikolaus", "Pankratius", "Paulus", "Placidus", "Quirinus",
    "Rochus", "Rupertus", "Sebastianus", "Severinus", "Stephanus", "Thaddäus", "Theodorus", "Ulrich",
    "Valentinus", "Vitus", "Wenzel", "Willibrord", "Wolfhelm", "Zacharias", "Zeno", "Adolf", "Ägidius",
    
    // Medieval German names
    "Adelger", "Adelgrim", "Adelheid", "Adolph", "Ägid", "Agilbert", "Agilulf", "Ailbert", "Alarich",
    "Alboin", "Aldric", "Alrich", "Altman", "Amalrich", "Ansbert", "Anselm", "Aribert", "Aribo",
    "Arnald", "Arnolt", "Artolf", "Ascwin", "Audomar", "Baldric", "Balther", "Bardolph", "Berengar",
    "Berenger", "Berhtram", "Berngrim", "Bernolf", "Bernward", "Bertold", "Bertulf", "Bligger", "Brunward",
    "Burchard", "Burkhard", "Dagobert", "Dietbald", "Dietbert", "Dietbold", "Dietger", "Diethard", "Diethelm",
    "Dietleib", "Dietlind", "Dietmar", "Dietram", "Dietrich", "Dietward", "Dietwin", "Eberwin", "Eckbert",
    "Eckbrecht", "Eckhard", "Edelbert", "Egbert", "Egilbert", "Eginhard", "Einhard", "Engelram", "Erdmann",
    "Erkenbald", "Erkenbert", "Fastred", "Fastulf", "Folcmar", "Folcwin", "Frideger", "Frithuric", "Gairebald",
    "Gairfrid", "Gautselin", "Gebwin", "Gerbert", "Gerhard", "Gerlach", "Gerold", "Gerulf", "Gerwin",
    "Giselbrecht", "Giselher", "Godabert", "Godebert", "Godehard", "Godescalc", "Godfried", "Godwin", "Gottschalk",
    "Gozbert", "Grimald", "Grimold", "Gundabert", "Gundahar", "Gundbert", "Gundobad", "Gunthar", "Guntram",
    "Hadamar", "Haidulf", "Haimirich", "Halitgar", "Harduin", "Hariolf", "Hartbert", "Hartlieb", "Hartmann",
    "Hathagrim", "Heidrich", "Heidenreich", "Heilwig", "Heimo", "Helmbert", "Helmold", "Helmward", "Heribald",
    "Heriger", "Herimann", "Hermengild", "Herwig", "Hesso", "Hezilo", "Hildebert", "Hildegar", "Hildegrim",
    "Hildeward", "Hiltibold", "Hludger", "Hrodbert", "Hrodgar", "Hruodland", "Hugbert", "Hunbert", "Hunfrid",
    "Hunold", "Irmbert", "Irmfrid", "Irmgard", "Isanbert", "Iso", "Karlmann", "Kerold", "Kunbert", "Landbert",
    "Landolf", "Lantbert", "Lantfrid", "Leodegar", "Leutbert", "Leutgar", "Leuthard", "Leuthold", "Liudbert",
    "Liudgar", "Liudger", "Liudolf", "Liudprand", "Liutbert", "Liutfried", "Liutgard", "Liuthard", "Liutpold",
    "Liutward", "Lothar", "Ludbert", "Ludger", "Ludolf", "Ludwin", "Maginhard", "Manegold", "Marcward",
    "Meginhard", "Meginher", "Meginold", "Meinhard", "Meinher", "Meinolf", "Meinrad", "Meinward", "Mengoz",
    "Nordbert", "Notger", "Notker", "Odbert", "Odgar", "Odilo", "Ordulf", "Oswald", "Otbert", "Otfrid",
    "Otger", "Othmar", "Otker", "Paldwin", "Pepin", "Poppo", "Raban", "Radbert", "Radbot", "Radbod",
    "Radolf", "Raganbert", "Raginbert", "Raginhild", "Raginold", "Rambert", "Ramold", "Ratbert", "Rathard",
    "Ratpold", "Reginald", "Reginbert", "Reginhard", "Reginold", "Reginward", "Regintrud", "Reinald", "Reinbold",
    "Reinfrid", "Rembert", "Ricbert", "Richbert", "Richildis", "Richolf", "Ricpert", "Riedeger", "Rimbert",
    "Ripwin", "Rodbert", "Rodger", "Rotbert", "Rotgar", "Ruodbert", "Ruodger", "Ruodlieb", "Ruodolf", "Ruotger",
    "Sarabert", "Segbert", "Sigibert", "Sigihard", "Sigimar", "Sigimund", "Sigiward", "Sigwin", "Sindbert",
    "Sindolf", "Sintram", "Siward", "Tancred", "Thankmar", "Theodbert", "Theodebert", "Theodegar", "Theoderich",
    "Theodger", "Theodoric", "Theutbert", "Thietbert", "Thietgar", "Thiethard", "Thietmar", "Thietwin", "Thurisind",
    "Unwan", "Walahfrid", "Walaric", "Walbrecht", "Waldebert", "Walpert", "Waltbert", "Waltger", "Wandalbert",
    "Wandabert", "Warin", "Warinbert", "Warmund", "Werinbert", "Werinhard", "Werner", "Wichbert", "Wichhard",
    "Wichmann", "Widald", "Widbert", "Widekind", "Widelo", "Widerad", "Widerich", "Widukind", "Wigbert",
    "Wigbert", "Wigger", "Wighard", "Wigmann", "Willbald", "Willbert", "Willehad", "Willibrord", "Willibald",
    "Winfrid", "Winimar", "Winther", "Wipo", "Wisbert", "Wittekind", "Wolfbert", "Wolfbrand", "Wolfger",
    "Wolfhard", "Wolfhere", "Wolfram", "Wulfhard", "Wulfric", "Wunibald", "Zetilo", "Zwentibold"
];

export const DE_FEMALE_NAMES = [
    // Most popular current German female names
    "Sofia", "Sophia", "Emma", "Emilia", "Mia", "Lina", "Mila", "Leni", "Lia", "Liah",
    "Lya", "Hannah", "Hanna", "Clara", "Klara", "Marie", "Emily", "Emilie", "Ella", "Lily",
    "Lilly", "Lilli", "Luna", "Malia", "Lea", "Leah", "Maja", "Maya", "Ida", "Mathilda",
    "Matilda", "Leonie", "Juna", "Yuna", "Nora", "Johanna", "Luisa", "Louisa", "Mira", "Frieda",
    "Frida", "Anna", "Ana", "Sophie", "Sofie", "Nele", "Neele", "Amelie", "Lena", "Charlotte",
    
    // Traditional German names
    "Adelheid", "Agnes", "Anneliese", "Astrid", "Barbara", "Beatrice", "Bertha", "Brigitte", "Brunhilde", "Christa",
    "Claudia", "Cornelia", "Dagmar", "Doris", "Edith", "Elisabeth", "Elke", "Erika", "Erna", "Eva",
    "Gabriele", "Gerda", "Gisela", "Gudrun", "Hannelore", "Heidi", "Helga", "Hildegard", "Ilse", "Ingeborg",
    "Ingrid", "Irene", "Johanna", "Karin", "Kerstin", "Lieselotte", "Margarete", "Margret", "Marianne", "Marlene",
    "Monika", "Petra", "Renate", "Rosemarie", "Ruth", "Sabine", "Sigrid", "Silke", "Susanne", "Ursula",
    
    // Regional variations and diminutives
    "Anke", "Antje", "Bärbel", "Beate", "Birgit", "Christel", "Dörte", "Eleonore", "Franziska", "Gabi",
    "Greta", "Grete", "Gretel", "Heike", "Hilde", "Inge", "Jutta", "Käthe", "Katrin", "Katja",
    "Lotte", "Lotti", "Magda", "Marga", "Margot", "Marlies", "Maxi", "Resi", "Susi", "Trudi",
    "Ulla", "Uschi", "Veronika", "Waltraud", "Wiebke", "Angelika", "Annette", "Antonia", "Bettina", "Bianca",
    "Carla", "Carolin", "Caroline", "Celia", "Christina", "Christine", "Claudine", "Daniela", "Diana", "Dorothea",
    
    // Modern German names
    "Alina", "Alya", "Aria", "Aurelia", "Ayla", "Chiara", "Kiara", "Dua", "Elena", "Eliana",
    "Finja", "Finnja", "Fiona", "Hailey", "Haylie", "Helena", "Ivy", "Jula", "Julia", "Kira",
    "Kyra", "Livia", "Malea", "Malina", "Milena", "Nina", "Olivia", "Paula", "Paulina", "Pauline",
    "Rosa", "Ruby", "Stella", "Tilda", "Valentina", "Victoria", "Viktoria", "Zoe", "Zoé", "Amalia",
    "Amelia", "Amira", "Ava", "Bella", "Carla", "Karla", "Dalia", "Edda", "Ema", "Evelyn",
    
    // Historical German names
    "Adalheid", "Adelheid", "Agatha", "Agathe", "Albertine", "Albina", "Amalia", "Anastasia", "Andrea", "Angelina",
    "Annemarie", "Annegret", "Annerose", "Antoinette", "Apollonia", "Augusta", "Babette", "Benedicta", "Bernadette", "Berta",
    "Bettina", "Brunhild", "Caecilia", "Cäcilia", "Cordula", "Crescentia", "Dorothee", "Ebba", "Edmunde", "Eleonora",
    "Elfriede", "Elsbeth", "Emilie", "Ernestine", "Eugenie", "Eulalia", "Felicitas", "Ferdinande", "Franziska", "Friederike",
    "Georgine", "Gertrud", "Gunda", "Hedwig", "Herta", "Hertha", "Hilda", "Hulda", "Ida", "Irma",
    
    // Saint names popular in Germany
    "Agatha", "Agnes", "Anastasia", "Angela", "Angelica", "Anita", "Anna", "Antonia", "Barbara", "Bernadette",
    "Brigida", "Brigitte", "Caecilia", "Cäcilia", "Carla", "Carmen", "Katharina", "Katarina", "Kathrin", "Katrin",
    "Cecilia", "Christina", "Claudia", "Cornelia", "Dorothea", "Elisabeth", "Emanuela", "Felicia", "Felicitas", "Gabriela",
    "Gabrielle", "Georgina", "Gertrud", "Gloria", "Hedwig", "Helena", "Hildegard", "Irmgard", "Johanna", "Josephine",
    "Josefine", "Juliana", "Juliane", "Katharina", "Lucia", "Lucinda", "Magdalena", "Margareta", "Margarete", "Maria",
    "Marianne", "Marina", "Martha", "Martina", "Monika", "Natalia", "Nikoletta", "Patricia", "Paula", "Petra",
    "Regina", "Rita", "Rosalia", "Rosalie", "Sabina", "Silvia", "Stefanie", "Stephanie", "Susanna", "Susanne",
    "Teresa", "Theresa", "Ursula", "Valeria", "Verena", "Veronica", "Veronika", "Victoria", "Viktoria", "Walburga",
    
    // Bavarian and Austrian influenced names
    "Afra", "Apollonia", "Benedicta", "Crescentia", "Eufemia", "Euphemia", "Genovefa", "Genoveva", "Hemma", "Hermina",
    "Hermine", "Humilitas", "Kunigunde", "Leonarda", "Leopoldine", "Lioba", "Maximiliana", "Notburga", "Ottilie", "Radegund",
    "Scholastika", "Serafina", "Sieglinde", "Thekla", "Walburga", "Waltraud", "Walpurga", "Wilhelmine", "Xaveria", "Zita",
    
    // Northern German names
    "Anke", "Antje", "Birte", "Dörte", "Franka", "Frauke", "Gesine", "Grete", "Heike", "Helke",
    "Imke", "Ineke", "Jantje", "Jutta", "Karin", "Kerstin", "Lotte", "Maike", "Meike", "Nantje",
    "Silke", "Svenja", "Thea", "Tina", "Trine", "Ulla", "Wiebke", "Wibke", "Rike", "Femke",
    "Gesa", "Gisela", "Hedda", "Hilda", "Inga", "Ingeborg", "Ingrid", "Janna", "Janne", "Jenna",
    "Kaja", "Kaya", "Caja", "Kersten", "Lara", "Lena", "Maren", "Marleen", "Marlen", "Merle",
    
    // Shortened forms and nicknames
    "Alex", "Alexa", "Ali", "Andi", "Angie", "Anni", "Annie", "Anny", "Bea", "Bella",
    "Betti", "Betty", "Caro", "Celi", "Chrissi", "Christi", "Conny", "Dani", "Ella", "Emmi",
    "Emmy", "Franzi", "Gabi", "Hanna", "Heidi", "Jule", "Juli", "Kathi", "Katy", "Lara",
    "Lea", "Lena", "Lilly", "Lisa", "Lotte", "Maggie", "Manu", "Mara", "Marla", "Maxi",
    "Mia", "Mila", "Mimi", "Moni", "Nana", "Nele", "Nelly", "Niki", "Nina", "Nora",
    "Resi", "Romy", "Sabi", "Sanni", "Steffi", "Susi", "Tanja", "Tina", "Toni", "Vicky",
    
    // International names popular in Germany
    "Adriana", "Alessia", "Alicia", "Alyssa", "Amanda", "Amy", "Andrea", "Angela", "Angelina", "Anita",
    "Anja", "Anna", "Anne", "Annabelle", "Antonia", "Ariana", "Beatrice", "Bianca", "Camila", "Carla",
    "Carmen", "Catalina", "Celine", "Céline", "Chiara", "Clara", "Claudia", "Cristina", "Dalila", "Daniela",
    "Diana", "Elena", "Elisa", "Elsa", "Esther", "Eva", "Fabiana", "Fatima", "Francesca", "Gabriela",
    "Gloria", "Grace", "Hanna", "Helena", "Irene", "Isabella", "Isabelle", "Jasmin", "Yasmin", "Julia",
    "Juliana", "Karina", "Katarina", "Laura", "Layla", "Leila", "Liana", "Lila", "Lina", "Lisa",
    "Lucia", "Luciana", "Luna", "Manuela", "Mariana", "Marina", "Martina", "Maya", "Melania", "Melissa",
    "Mia", "Michelle", "Monica", "Nadia", "Natalia", "Nicole", "Nina", "Olivia", "Patricia", "Paula",
    "Paola", "Rebecca", "Sabrina", "Sandra", "Sara", "Sarah", "Selina", "Serena", "Sofia", "Sophia",
    "Stella", "Tara", "Valentina", "Valeria", "Vanessa", "Vera", "Victoria", "Viktoria", "Ximena", "Zara",
    
    // Modern trendy names
    "Aria", "Arya", "Ava", "Bella", "Chloe", "Emma", "Eva", "Grace", "Harper", "Isabella",
    "Jade", "Layla", "Leila", "Lila", "Luna", "Mila", "Nova", "Ruby", "Scarlett", "Stella",
    "Zara", "Zoe", "Aaliyah", "Aliya", "Amara", "Aurora", "Cora", "Dua", "Eden", "Elara",
    "Freya", "Hailey", "Haylie", "Ivy", "Kira", "Kyra", "Lara", "Leyla", "Mara", "Maya",
    "Nala", "Nahla", "Naya", "Noa", "Nora", "Raya", "Skye", "Tara", "Vera", "Zara",
    
    // Compound German names
    "Anna-Lena", "Anna-Maria", "Eva-Maria", "Lena-Marie", "Lisa-Marie", "Marie-Claire", "Marie-Louise", "Sarah-Jane",
    "Anne-Sophie", "Marie-Therese", "Anna-Sophie", "Lea-Sophie", "Emma-Sophie", "Mia-Sophie", "Lina-Sophie", "Ella-Marie",
    
    // Germanic names with meaning
    "Adelheid", "Adeline", "Albertine", "Brunhilde", "Clothilde", "Ermengarde", "Fredegund", "Gertrude", "Grizelda",
    "Gunhild", "Heriberta", "Hermine", "Hildegard", "Irmgard", "Kunigunde", "Leopoldine", "Mathilde", "Mechtild",
    "Ottilie", "Radegund", "Roswitha", "Sieglinde", "Theodora", "Walburga", "Wilhelmine", "Winifred", "Walpurga",
    
    // Medieval German female names
    "Adelheid", "Adelgund", "Adelinde", "Adeltrud", "Agatha", "Albertine", "Amalia", "Anastasia", "Apollonia", "Augusta",
    "Beatrix", "Benedicta", "Berchta", "Bertha", "Brunhild", "Caecilia", "Crescentia", "Cunigund", "Dorothea", "Eberga",
    "Edith", "Elisabet", "Ermengard", "Euphemia", "Felicitas", "Frederica", "Genovefa", "Gerberga", "Gertrud", "Gisla",
    "Gunthild", "Hadwig", "Hemma", "Herberga", "Hermine", "Hilda", "Hildeburg", "Hildegard", "Humilitas", "Ida",
    "Irmgard", "Judith", "Kunigund", "Lioba", "Liutgard", "Mathild", "Mechthild", "Notburg", "Ottilia", "Radegund",
    "Richgard", "Roswitha", "Scholastica", "Sieglind", "Theodora", "Thietburg", "Waldburg", "Waltraud", "Willibirg", "Wunibald",
    
    // Nature-inspired names
    "Blume", "Iris", "Jasmin", "Lilie", "Margrit", "Rosa", "Rose", "Rosemarie", "Roswitha", "Veilchen",
    "Violetta", "Viola", "Flora", "Fleur", "Heide", "Linde", "Primula", "Kornblume", "Nelke", "Tulpe",
    
    // Virtue names
    "Caritas", "Clementia", "Concordia", "Constantia", "Felicitas", "Fides", "Gloria", "Gratia", "Humilitas", "Justitia",
    "Pax", "Prudentia", "Spes", "Veritas", "Victoria", "Sapientia", "Temperantia", "Fortitudo", "Libertas", "Benignitas",
    
    // Names from literature and arts
    "Brunhild", "Kriemhild", "Isolde", "Gudrun", "Sieglinde", "Ortrud", "Elsa", "Elisabeth", "Gretchen", "Margarete",
    "Faust", "Mignon", "Ottilie", "Charlotte", "Lotte", "Werther", "Effi", "Fontane", "Undine", "Lorelei",
    
    // Regional spellings and variants
    "Katharine", "Catherine", "Catharina", "Katarine", "Katarina", "Kathrin", "Katrin", "Katja", "Käthe", "Kathi",
    "Elisabeth", "Elizabeth", "Elisabet", "Elsbeth", "Else", "Elsa", "Lisbeth", "Lisa", "Liesel", "Liese",
    "Margarete", "Margaret", "Margareta", "Margret", "Margrit", "Grete", "Greta", "Gretel", "Magda", "Marga",
    "Johanna", "Johanne", "Hanna", "Hannah", "Janna", "Janne", "Hanne", "Hannelore", "Anneliese", "Annemarie",
    "Christina", "Christine", "Christiane", "Christa", "Christel", "Tina", "Kerstin", "Kirsten", "Kristin", "Kristina",
    
    // Diminutive forms
    "Adelchen", "Ännchen", "Bärbchen", "Bettchen", "Charlottchen", "Dorchen", "Evchen", "Gretchen", "Hannchen", "Liesbeth",
    "Lieschen", "Lottchen", "Mariechen", "Röschen", "Suschen", "Trudchen", "Ännchen", "Beate", "Dörthe", "Elke",
    "Frauke", "Gesine", "Heike", "Imke", "Jutta", "Lotte", "Maike", "Meike", "Silke", "Ulla",
    
    // Modern compound names
    "Anneliese", "Annemarie", "Annerose", "Hannelore", "Liselotte", "Mariechen", "Rosemarie", "Roselinde", "Annabell", "Annabelle",
    "Marianne", "Marieluise", "Annamaria", "Elisabetta", "Mariella", "Annalea", "Marialena", "Rosalinde", "Rosamunde", "Adelgunde"
];

export const DE_LAST_NAMES = [
    // Most common German surnames (from research)
    "Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann",
    "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann",
    "Braun", "Krüger", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause", "Meier",
    "Lehmann", "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "Walter", "Mayer", "Huber", "Kaiser",
    "Fuchs", "Peters", "Möller", "Lang", "Scholz", "Weiß", "Jung", "Hahn", "Schubert", "Vogel",
    
    // Occupational surnames
    "Bäcker", "Fleischer", "Metzger", "Tischler", "Maurer", "Gärtner", "Förster", "Jäger", "Kaufmann", "Krämer",
    "Schlüter", "Seiler", "Schuster", "Schumacher", "Gerber", "Schmied", "Goldschmidt", "Silberschmidt", "Kupferschmidt", "Eisenschmidt",
    "Kellner", "Wirt", "Brauer", "Brenner", "Destillateur", "Mühlbauer", "Sattler", "Wagner", "Kutschner", "Fuhrmann",
    "Schiffer", "Bootsmann", "Steuermann", "Kapitän", "Admiral", "General", "Oberst", "Major", "Hauptmann", "Leutnant",
    "Richter", "Notar", "Anwalt", "Advokat", "Prokurator", "Syndikus", "Schreiber", "Sekretär", "Beamter", "Verwalter",
    
    // Geographic/topographic surnames
    "Berg", "Berger", "Bergmann", "Hügel", "Tal", "Taler", "Bach", "Bacher", "Fluss", "Wald",
    "Waldmann", "Busch", "Baum", "Baumgarten", "Garten", "Feld", "Feldmann", "Wiese", "Steinbach", "Steinberg",
    "Felsen", "Fels", "Hain", "Heide", "Moor", "Sumpf", "See", "Teich", "Quelle", "Born",
    "Brücke", "Tor", "Pforte", "Weg", "Straße", "Pfad", "Steig", "Hang", "Abhang", "Plateau",
    "Ebene", "Höhe", "Spitze", "Gipfel", "Kuppe", "Kamm", "Rücken", "Senke", "Mulde", "Kuhle",
    
    // From personal characteristics
    "Groß", "Großmann", "Klein", "Kleinmann", "Lang", "Lange", "Kurz", "Dick", "Dünn", "Stark",
    "Schwach", "Jung", "Alt", "Neu", "Neumann", "Weiß", "Schwarz", "Braun", "Grau", "Rot",
    "Grün", "Blau", "Gelb", "Schnell", "Langsam", "Klug", "Weise", "Dumm", "Schön", "Hübsch",
    "Hässlich", "Freundlich", "Böse", "Gut", "Schlecht", "Fleißig", "Faul", "Mutig", "Feige", "Stolz",
    "Demütig", "Ehrlich", "Verlogen", "Treu", "Falsch", "Sauber", "Schmutzig", "Ordentlich", "Unordentlich", "Pünktlich",
    
    // Regional German surnames
    "Bayer", "Baier", "Schwabe", "Franke", "Frank", "Hesse", "Westfale", "Sachse", "Preuße", "Böhme",
    "Mähre", "Schlesier", "Pommer", "Braunschweiger", "Hannoveraner", "Hamburger", "Berliner", "Münchner", "Kölner", "Frankfurter",
    "Wiener", "Salzburger", "Tiroler", "Steirer", "Kärntner", "Oberösterreicher", "Niederösterreicher", "Burgenländer", "Vorarlberger", "Rheinländer",
    "Westfale", "Niedersachse", "Hesse", "Thüringer", "Sachse", "Brandenburger", "Mecklenburger", "Schleswig-Holsteiner", "Badener", "Württemberger",
    
    // Patronymic surnames
    "Hansen", "Hanson", "Jansen", "Janssen", "Janzen", "Peters", "Petersen", "Andersen", "Anderson", "Nielsen",
    "Nilsen", "Larsen", "Larson", "Olsen", "Olson", "Eriksen", "Erikson", "Sörensen", "Sörenson", "Johannsen",
    "Johannson", "Thomsen", "Thomson", "Jacobsen", "Jacobson", "Rasmussen", "Christensen", "Christiansen", "Mortensen", "Kristensen",
    
    // Religious surnames
    "Kirch", "Kirchner", "Kircher", "Pfarrer", "Pastor", "Priester", "Abt", "Mönch", "Kloster", "Klostermann",
    "Kapelle", "Kapellmeister", "Diakon", "Bischof", "Erzbischof", "Kardinal", "Papst", "Heilig", "Fromm", "Gottesfürchtig",
    "Christlich", "Katholisch", "Evangelisch", "Lutherisch", "Reformiert", "Pietistisch", "Methodistisch", "Baptistisch", "Mennonitisch", "Quäkerisch",
    
    // Nobility and titles
    "Graf", "Herzog", "Fürst", "Baron", "Freiherr", "Ritter", "Edler", "Adelig", "Adler", "König",
    "Kaiser", "Prinz", "Markgraf", "Landgraf", "Pfalzgraf", "Burgraf", "Reichsgraf", "Reichsfreiherr", "Reichsritter", "Hofrat",
    "Geheimrat", "Staatsrat", "Regierungsrat", "Ministerialrat", "Oberregierungsrat", "Kanzler", "Vizekanzler", "Minister", "Staatssekretär", "Botschafter",
    
    // House names and dwelling places
    "Haus", "Hausmann", "Hof", "Hofmann", "Hütte", "Hütter", "Schloss", "Burg", "Turm", "Mauer",
    "Wand", "Dach", "Keller", "Boden", "Fenster", "Tür", "Tor", "Pforte", "Zaun", "Gatter",
    "Garten", "Hof", "Scheune", "Stall", "Mühle", "Bäckerei", "Schmiede", "Werkstatt", "Laden", "Markt",
    
    // Animal-related surnames
    "Wolf", "Wolff", "Fuchs", "Bär", "Hirsch", "Reh", "Hase", "Kaninchen", "Hund", "Katze",
    "Pferd", "Kuh", "Stier", "Ochse", "Schwein", "Schaf", "Lamm", "Ziege", "Hahn", "Huhn",
    "Ente", "Gans", "Schwan", "Adler", "Falke", "Sperber", "Bussard", "Milan", "Habicht", "Eule",
    "Krähe", "Rabe", "Elster", "Specht", "Lerche", "Nachtigall", "Drossel", "Amsel", "Star", "Fink",
    
    // Plant-related surnames
    "Rose", "Rosen", "Lilie", "Nelke", "Tulpe", "Veilchen", "Margrit", "Jasmin", "Iris", "Krokus",
    "Eiche", "Buche", "Birke", "Tanne", "Fichte", "Kiefer", "Linde", "Ahorn", "Ulme", "Esche",
    "Weide", "Pappel", "Erle", "Haselnuss", "Walnuss", "Kastanie", "Apfel", "Birne", "Kirsche", "Pflaume",
    "Traube", "Beere", "Erdbeere", "Himbeere", "Brombeere", "Johannisbeere", "Stachelbeere", "Heidelbeere", "Preiselbeere", "Holunder",
    
    // Color-related surnames
    "Weißmann", "Schwarzmann", "Braunmann", "Grauemann", "Rotmann", "Grünwald", "Blaustein", "Gelbinger", "Violett", "Orange",
    "Rosa", "Silber", "Gold", "Bronze", "Kupfer", "Eisen", "Stahl", "Blei", "Zinn", "Messing",
    
    // Weather-related surnames
    "Sturm", "Wind", "Wirbel", "Regen", "Schneemann", "Hagel", "Frost", "Eis", "Tau", "Nebel",
    "Wolke", "Himmel", "Sonne", "Mond", "Stern", "Blitz", "Donner", "Gewitter", "Orkan", "Hurrikan",
    
    // Time-related surnames
    "Sommer", "Winter", "Frühling", "Herbst", "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember", "Montag", "Dienstag", "Mittwoch", "Donnerstag",
    "Freitag", "Samstag", "Sonntag", "Morgen", "Mittag", "Abend", "Nacht", "Tag", "Woche", "Monat",
    
    // Tool and object surnames
    "Hammer", "Nagel", "Säge", "Axt", "Beil", "Messer", "Gabel", "Löffel", "Teller", "Schüssel",
    "Topf", "Pfanne", "Kessel", "Eimer", "Fass", "Krug", "Becher", "Glas", "Flasche", "Kanne",
    "Schreibfeder", "Tinte", "Papier", "Buch", "Brief", "Siegel", "Schlüssel", "Schloss", "Kette", "Ring",
    
    // Germanic tribal names
    "Alemanne", "Bajuware", "Sachse", "Franke", "Thüringer", "Friese", "Schwabe", "Hesse", "Westfale", "Ostfale",
    "Angelsachse", "Jute", "Normanne", "Wikinger", "Vandal", "Gote", "Langobarde", "Burgunder", "Rugier", "Gepide",
    
    // Medieval professions
    "Ritter", "Knappe", "Schildknappe", "Bogenschütze", "Armbrustschütze", "Schwertträger", "Lanzenträger", "Fahnenträger", "Trompeter", "Spielmann",
    "Minnesänger", "Barde", "Jongleur", "Gaukler", "Narr", "Hofnarr", "Zauberer", "Wahrsager", "Alchemist", "Astrologe",
    
    // Academic and scholarly surnames
    "Doktor", "Professor", "Magister", "Lehrer", "Schulmeister", "Gelehrter", "Philosoph", "Theologe", "Jurist", "Mediziner",
    "Mathematiker", "Astronom", "Physiker", "Chemiker", "Biologe", "Botaniker", "Zoologe", "Geologe", "Archäologe", "Historiker",
    
    // Merchant and trade surnames
    "Händler", "Verkäufer", "Käufer", "Makler", "Kommissionär", "Spediteur", "Importeur", "Exporteur", "Großhändler", "Einzelhändler",
    "Tuchhändler", "Gewürzhändler", "Salzhändler", "Weinhändler", "Bierhändler", "Fleischhändler", "Fischhändler", "Obsthändler", "Gemüsehändler", "Bäckerei",
    
    // Military surnames
    "Soldat", "Krieger", "Kämpfer", "Veteran", "Offizier", "Unteroffizier", "Feldwebel", "Sergeant", "Korporal", "Gefreiter",
    "Rekrut", "Wachmann", "Posten", "Sentry", "Garde", "Gardist", "Grenadier", "Husar", "Ulan", "Kürassier",
    
    // Naval surnames
    "Seemann", "Matrose", "Bootsmann", "Steuermann", "Navigator", "Kapitän", "Admiral", "Korvettenkapitän", "Fregattenkapitän", "Linienschiffskapitän",
    "Konteradmiral", "Vizeadmiral", "Großadmiral", "Flottenadmiral", "Hafenmeister", "Lotse", "Leuchtturmwärter", "Zollbeamter", "Wasserschutzpolizist", "Küstenwache",
    
    // Food-related surnames
    "Brot", "Kuchen", "Torte", "Gebäck", "Semmel", "Brezel", "Zwieback", "Keks", "Wurst", "Schinken",
    "Speck", "Fleisch", "Fisch", "Käse", "Butter", "Milch", "Sahne", "Quark", "Joghurt", "Honig",
    "Zucker", "Salz", "Pfeffer", "Gewürz", "Kräuter", "Petersilie", "Dill", "Schnittlauch", "Basilikum", "Oregano",
    
    // Construction and building surnames
    "Zimmermann", "Maurer", "Dachdecker", "Klempner", "Installateur", "Elektriker", "Maler", "Anstreicher", "Tapezier", "Glaser",
    "Schlosser", "Schreiner", "Tischler", "Möbelbauer", "Stuhlmacher", "Tischmacher", "Schrankmacher", "Bettenmacher", "Polsterer", "Sattler",
    
    // Textile and clothing surnames
    "Weber", "Spinner", "Färber", "Walker", "Tuchmaker", "Schneider", "Näher", "Kleidermacher", "Hutmacher", "Schuhmacher",
    "Schuster", "Gerber", "Lederer", "Kürschner", "Pelzhändler", "Strumpfwirker", "Handschuhmacher", "Gürtelmacher", "Taschenmacher", "Knöpfemacher",
    
    // Music and entertainment surnames
    "Musiker", "Sänger", "Dirigent", "Komponist", "Violinist", "Pianist", "Flötist", "Trompeter", "Posaunist", "Schlagzeuger",
    "Harfenist", "Organist", "Chorleiter", "Kapellmeister", "Konzertmeister", "Solist", "Virtuose", "Künstler", "Maler", "Bildhauer",
    
    // Transport and travel surnames
    "Fuhrmann", "Kutscher", "Postbote", "Briefträger", "Paketzusteller", "Spediteur", "Frachtführer", "Lastwagenfahrer", "Omnibusfahrer", "Straßenbahnfahrer",
    "Eisenbahner", "Lokomotivführer", "Schaffner", "Bahnhofsvorsteher", "Weichensteller", "Gleisarbeiter", "Signalwärter", "Stationsvorsteher", "Fahrkartenkontrolleur", "Gepäckträger",
    
    // Administrative surnames
    "Beamter", "Verwaltungsbeamter", "Regierungsbeamter", "Staatsbeamter", "Gemeindebeamter", "Stadtbeamter", "Kreisbeamter", "Bezirksbeamter", "Landesbeamter", "Bundesbeamter",
    "Bürgermeister", "Stadtrat", "Gemeinderat", "Kreisrat", "Bezirksrat", "Landrat", "Regierungspräsident", "Minister", "Staatssekretär", "Ministerialdirektor"
];